export function getAuthToken() {
    const params = JSON.parse(localStorage.getItem('appParams'));
    return params?.token;
}

export function getEnvironmentParams() {
    // Token extraction is now handled centrally by useTokenHandler hook
    // This function just retrieves the stored params from localStorage
    const params = JSON.parse(localStorage.getItem('appParams')) || {};
    return {
        token: params?.token
    };
} 